import { useSpecialtyDisplayName } from '@/hooks/useSpecialtyDisplayName';
import { Chip } from '@heidi/design-system/chip';
import { TypographyP2Bold } from '@heidi/design-system/typography';
import type { DetailedPublicTemplateResponse } from '@heidi/templates/contracts';
import { useIntl } from 'react-intl';
import { getTemplateCategoryFilterLabel } from '../../communityFilters.messages';

interface TemplateTagsProps {
  emphasizeText?: boolean;
  onBadgeClick: (type: 'specialty' | 'category') => void;
  template: DetailedPublicTemplateResponse | undefined;
}

const TemplateTagLabel = ({
  children,
  emphasizeText = false,
}: {
  children: string | undefined;
  emphasizeText?: boolean;
}) => {
  if (emphasizeText) {
    return <TypographyP2Bold className="text-text-primary">{children}</TypographyP2Bold>;
  }

  return children;
};

export const TemplateTags = ({
  emphasizeText = false,
  onBadgeClick,
  template,
}: TemplateTagsProps) => {
  const intl = useIntl();
  const getSpecialtyDisplayName = useSpecialtyDisplayName();

  return (
    <div className="flex flex-wrap gap-2">
      {template && (
        <Chip color="neutral" onClick={() => onBadgeClick('specialty')}>
          <TemplateTagLabel emphasizeText={emphasizeText}>
            {getSpecialtyDisplayName(template.specialty ?? '')}
          </TemplateTagLabel>
        </Chip>
      )}
      {template && (
        <Chip onClick={() => onBadgeClick('category')} color="neutral">
          <TemplateTagLabel emphasizeText={emphasizeText}>
            {getTemplateCategoryFilterLabel(intl, template.template_category)}
          </TemplateTagLabel>
        </Chip>
      )}
    </div>
  );
};
